import { Model } from 'es6/components/model'
import isArray from 'lodash/isArray'
import head from 'lodash/head'
import find from 'lodash/find'
import isNumber from 'lodash/isNumber'
import isNaN from 'lodash/isNaN'
import { entryScriptName } from 'init/entry-script-name'
import { photoCDN } from 'init/photo-cdn'
import { Defaults } from 'es-decorators'

/**
 * Модель для товара
 */
@Defaults({
  urlRoot: `${entryScriptName}/api/v3/item-search`,
  FILE_ID_3D_MODEL: 7,
})
export class Item extends Model {
  /**
   * Получение Url для товара
   * @returns {string} Url
   */
  getUrl () {
    return `${entryScriptName}/${this.get('sid')}/${this.get('slug')}/`
  }

  /**
   * Получение Url для товара с GET параметрами
   * @returns {string|null} Url
   */
  getRootUrlWithQueries () {
    return this.get('sid') && this.get('slug') ? `/${this.get('sid')}/${this.get('slug')}/${window.location.search}` : null
  }

  /**
   * Получить url до фото с указанным номером и указанным размером
   * @param {number} n
   * @param {number} size
   * @returns {string} Url
   */
  getPhotoUrl (n, size = 140) {
    if (n === undefined || n === null) {
      n = this.getFirstIndexPhoto()
    }
    let productIdStr = '' + this.get('id'),
      photoIndexes = this.get('photoIndexes')
    if (isArray(photoIndexes) && photoIndexes.length && photoIndexes.indexOf(n.toString()) !== -1) {
      let photoVersion = this.getPhotoVersion(n)
      return `${photoCDN}/items/${productIdStr}/${n}/${size}.jpg?v=${photoVersion}`
    }
    return `${photoCDN}/items/default/${size}.jpg`
  }

  /**
   * Получить индекс первого фото
   * @returns {number} индекс, либо 0
   */
  getFirstIndexPhoto () {
    let indexes = this.get('photoIndexes')
    if (indexes) {
      return indexes[0]
    }
    return 0
  }

  /**
   * Получение первого 3d фото
   * @returns {*} первое 3d фото, либо пустая строка
   */
  getFirstPhoto3d () {
    let photo3ds = this.get('itemPhoto3ds')
    if (photo3ds) {
      return head(photo3ds)
    }
    return ''
  }

  /**
   * Получить версию фото с указанным индексом
   * @param {number} index
   * @returns {number} версия фото, либо 0
   */
  getPhotoVersion (index) {
    let photoVersions = this.get('photoVersions')
    let photo = find(photoVersions, ['number', index + ''])

    if (photo) {
      let version = parseInt(photo.version, 10)
      if (isNumber(version) && !isNaN(version)) {
        return version
      }
    }
    return 0
  }

  /**
   * Файл '3D модель'
   * @returns {Object|undefined} Данные о файле с 3d моделью
   */
  get3dModelFile () {
    const itemsFiles = this.get('files')
    return find(itemsFiles, { type_id: this.FILE_ID_3D_MODEL })
  }

  /** @inheritDoc */
  parse (resp) {
    if (resp.badges && resp.badges.length) {
      resp.badges = Item.getBadges(resp.badges, resp._meta.badges)
    }
    return resp
  }

  /**
   * Возвращает объект с шильдиками.
   * @static
   * @param {Object} badges Шильдики текущего товара.
   * @param {Object} badgesTemplates Шаблоны шильдиков, приходят вместе
   *                                 с товаром|коллекцией товаров в `_meta.badges`.
   * @returns {Array} Массив с шильдиками.
   */
  static getBadges (badges, badgesTemplates) {
    return badges.map(function (badge) {
      const templates = Object.assign({}, badgesTemplates[badge.type])
      return Object.assign(templates, badge)
    })
  }

  /**
   * Возвращает фото с необходимым размером.
   * @static
   * @param {Array} photos Массив с данными фотографиями.
   * @param {number} [index=0] Индекс возвращаемой фотографии.
   * @param {number} [size=140] Размер фото.
   * @returns {string} Полный URL до фото.
   */
  static getPhotoUrl (photos, index = 0, size = 140) {
    return `${photos[index].url_part}${size}.jpg${photos[index].version ? `?v=${photos[index].version}` : ''}`
  }
}
